import type { ReactNode } from 'react'

type SurfaceCardProps = {
    title?: string
    description?: string
    children: ReactNode
}

export const SurfaceCard = ({ title, description, children }: SurfaceCardProps) => {
    return (
        <section className="border-account-divider bg-account-surface overflow-hidden rounded-xl border shadow-sm">
            {(title || description) && (
                <div className="border-account-divider border-b px-6 py-5">
                    {title && <h2 className="text-account-strong text-lg font-bold">{title}</h2>}
                    {description && <p className="text-account-secondary mt-1 text-sm">{description}</p>}
                </div>
            )}
            <div className="p-6">{children}</div>
        </section>
    )
}
